var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"qr"},[_vm._m(0),_c('div',{staticClass:"qr__zone"},[_c('qrcode-stream',{on:{"decode":_vm.onDecode,"init":_vm.onInit}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text"},[_vm._v("QR코드로 간편하게"),_c('br'),_vm._v("로또당첨 확인하세요")])
}]

export { render, staticRenderFns }